<template>
<div class="section drawings">
  <div class="section__header">
    <h2>Конкурс поделок</h2>
    <back></back>

    <div class="header-menu">
      <button 
        type="button" 
        class="header-menu__btn" 
        @click="openPopup('AddDraw', null)"
        v-show="isMaster"
      >
        <i class="fas fa-plus"></i>
        Загрузить рисунок
      </button>
    </div>
  </div>

  <div class="section__body drawings__content">
    <h3>Голосуй за понравившиеся работы!</h3>
    <span>Всего работ: {{ drawings.length }}</span>
    <ul class="drawings-list" v-if="drawings.length">
      <li class="drawings__item" v-for="item in drawings" :key="item.id">
        <div class="drawings__item-container">
          <div class="drawings__field">
            <div class="sh-products__image" uk-lightbox>
              <a :href="item.href"><img :src="item.href" :alt="item.title"></a>
            </div>
            <div class="sh-products__title">{{ item.title }}</div>
          </div>

          <div class="drawings__field">
            <star-rating 
              :show-rating="false" 
              :star-size="25" 
              :rating="item.user_score ? item.user_score : 0"
              @rating-selected="rateDrawing(item, $event)" 
            />
            <span class="total-rating">Всего баллов: {{ item.score }}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData" 
        @close-popup="popupIsOpened = false" 
        @add-drawings="drawings = drawings.concat($event)"
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import StarRating from 'vue-star-rating'
import AddDraw from './AddDraw.vue'
import { mapGetters } from 'vuex'
import { popup_mix } from '../../../mixins/popup_mix'
export default {
  inject: ['http'],
  components: { StarRating, AddDraw },
  mixins: [ popup_mix ],
  data() {
    return {
      drawings: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    isMaster() {
      if (this.user.role.id === 1 && this.user.property) {
        return +this.user.property.is_master ? true : false
      }
      return false      
    }   
  },
  methods: {
    rateDrawing(item, rating) {
      if (this.user.role.id === 1) {
        swal('Увы', 'Учителя не могут участвовать в голосовании', 'warning')
      } else {
        let message = item.user_score ? `Хотите изменить свою оценку (${item.user_score})?` : `Оценить этот рисунок на ${rating} балла(-ов)?`

        swal({
          title: 'Внимание!',
          text: message,
          icon: "warning",
          buttons: ['Отмена', 'Да'],
          dangerMode: true,
        })
        .then((choise) => {
          let data = {
            user_id: this.user.id,
            id: item.id,
            rating
          }
          if (choise) {
            this.http.post('onSaveVote', data).then(() => {
              if (!item.user_score) {
                item.score += rating              
              } else {
                item.score = item.score - item.user_score + rating
              }
              item.user_score = rating
              
              swal('Успешно!', 'Ваш голос отправлен', 'success')
            }) 
            .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
          } 
        })  
      }
    }
  },
  created() {
    this.http.post('onGetContests').then(res => console.log(res.data))
    this.http.post('onGetContestFiles', { contest_id: 1 }).then(res => {
      this.drawings = res.data
      console.log(this.drawings)
    })
    .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
  }
}
</script>

<style lang="scss" scoped>
.drawings-list {
  margin-top: 40px;
  padding: 0;
  width: 100%;

  list-style: none;
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
}

.drawings__item {
  padding: 10px;
  position: relative;
  width: 240px;
}

.drawings__item-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-shadow: 0 2px 6px 0 #bbbbbb;
  border-radius: 8px;
  text-align: center;
}

.drawings__field {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.section__header {
  padding-bottom: 20px;
}

.sh-products__image {
  width: 100%;
  box-shadow: none;
  border: 1px solid #d4d4d4;
  border-radius: 8px;
  box-sizing: border-box;
}

.total-rating {
  margin-top: 10px;
  font-size: 14px;
  color: #999999;
}
</style>